import React from "react";

export const EducationPlayIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <circle cx="40" cy="40" r="40" fill="rgba(34, 34, 34, 0.5)" />
    <path
      d="M52 40L34 52V28L52 40Z"
      fill="#ffffff"
    />
  </svg>
);

export const EducationMoreIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#1E3A6D" />
    <path
      d="M10.0003 5.91675V14.0834M5.91699 10.0001H14.0837"
      stroke="#1E3A6D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
